import Vue from 'vue'

function toastSuccess(message = 'Sucesso!') {
    Vue.prototype.$toasted.show(message, {type: 'success', position: 'bottom-right'})
}

function toastError(message = 'Falha!') {
    Vue.prototype.$toasted.show(message, {type: 'error', position: 'bottom-right'})
}

export default { toastSuccess, toastError }